<template>
  <div class="main_container">
    <div class="task_detail_container">

      <!-- 详情页头部 -->
      <detail-title
        :backToPath="'/admin/manager'"
        :descriptionList="descriptionList"
      ></detail-title>

      <!-- 详情信息列表 -->
      <task-description
        :isMaterials="true"
        :descriptionList="descriptionList">
      </task-description>

      <!-- 修改任务奖励按钮 -->
      <div class="task_submit">
        <el-button
          v-if="descriptionList.status === TASK_STATUS.WAITING_FOR_REWARDS"
          size="small"
          type="primary"
          @click="updateAwardsVisible = true">
          修改任务奖励
        </el-button>
      </div>

    </div>

    <!-- 任务相关信息 -->
    <task-related-info></task-related-info>

    <!-- 修改任务奖励对话框 -->
    <update-awards-dialog :visible.sync="updateAwardsVisible"></update-awards-dialog>
  </div>
</template>

<script>
import api from '@/api/index'
import UpdateAwardsDialog from '../components/update-awards-dialog.vue'
import TaskRelatedInfo from '@/components/task-detail/related-info/index.vue'
import DetailTitle from '@/components/task-detail/title/index.vue'
import TaskDescription from '@/components/task-detail/description/index.vue'
import globalVar from '@/configs/globalVar'

export default {
  components: {
    TaskRelatedInfo,
    DetailTitle,
    UpdateAwardsDialog,
    TaskDescription
  },
  data () {
    return {
      updateAwardsVisible: false,
      loading: false,
      descriptionList: {}
    }
  },
  computed: {
    taskId () {
      return this.$route.params.taskId
    },
    TASK_STATUS () {
      return globalVar.TASK_STATUS
    }
  },
  created () {
    this.getTaskDetail()
  },
  methods: {
    handleUpdateAwards () {
      this.offTaskVisible = false
    },
    getTaskDetail () {
      this.loading = true
      api.taskDetail(this.taskId).then(res => {
        if (res.data.code === 0) {
          this.descriptionList = res.data.data ? res.data.data : {}
        } else {
          this.$message.error('获取信息失败')
        }
      }).catch(() => {
        this.$message.error('请求异常')
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.main_container {
  width: 100%;
  height: 100%;
  display: flex;
}
.task_detail_container {
  min-width: 1200px;
  height: 100%;
  background-color: #fff;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.06);
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: auto;
  .task_submit {
    height: 80px;
    padding: 0 30px;
    border-top: 1px solid #E4E7ED;
    display: flex;
    align-items: center;
  }
}
</style>
